import { twMerge } from 'tailwind-merge';

import useActivityPendencyColumns, {
  ActivityPendencyColumnKey,
} from '@/data/hook/shared/pendencies/tables/useActivityPendencyColumns';
import { ActivityProgressOrdering } from '@/data/services/activityProgressServices';
import ActivityProgress from '@/models/ActivityProgress';
import { OrderingKey } from '@/models/Filter';
import { SmartTable, SmartTableProps } from '@/components/ui/daisy';

type ActivityPendenciesTableProps = Omit<
  SmartTableProps<ActivityProgress, ActivityPendencyColumnKey>,
  'columns' | 'getRowKey'
> & {
  ordering?: ActivityProgressOrdering;
  onToggleOrdering: (field: OrderingKey<ActivityProgressOrdering>) => void;
};

export default function ActivityPendenciesTable({
  ordering,
  onToggleOrdering,
  className,
  ...smartTableProps
}: ActivityPendenciesTableProps) {
  const columns = useActivityPendencyColumns({
    ordering,
    onToggleOrdering,
  });

  return (
    <SmartTable
      columns={columns}
      getRowKey={pendingActivity => pendingActivity.id}
      className={twMerge('table-fixed', className)}
      {...smartTableProps}
    />
  );
}
